/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_TitleInputs */

const en_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce and Amazon Seller Tooling`)
};

const ar_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدوات التجارة الإلكترونية وبائعي أمازون`)
};

const bn_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ই-কমার্স ও আমাজন সেলার টুলিং`)
};

const de_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Commerce- und Amazon-Seller-Tooling`)
};

const es_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas para e-commerce y vendedores de Amazon`)
};

const fr_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outillage e-commerce et vendeurs Amazon`)
};

const pt_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas para e-commerce e vendedores da Amazon`)
};

const zh_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电商与亚马逊卖家工具`)
};

const tr_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaret ve Amazon Satıcı Araçları`)
};

const ru_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструменты e-commerce и продавцов Amazon`)
};

const pl_svc_ecommerce_amazon_tools_title = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narzędzia e-commerce i sprzedawców Amazon`)
};

/**
* | output |
* | --- |
* | "E-commerce and Amazon Seller Tooling" |
*
* @param {Svc_Ecommerce_Amazon_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_title = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_title(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_title(inputs)
	return en_svc_ecommerce_amazon_tools_title(inputs)
});
export { svc_ecommerce_amazon_tools_title as "svc_ecommerce-amazon-tools_title" }